import type { Question, Option } from "../types/survey";

export function getRevealedQuestionIds(questions: Question[]): Set<string> {
  const revealedQuestionIds = new Set<string>();
  questions.forEach(q => {
    q.options?.forEach(option => {
      if (option.revealQuestionId) {
        option.revealQuestionId.split(',').map((id: string) => id.trim()).forEach((id: string) => {
          if (id) revealedQuestionIds.add(id);
        });
      }
    });
  });
  return revealedQuestionIds;
}

export function shouldShowQuestion(
  q: Question,
  revealedQuestionIds: Set<string>,
  responses: Record<string, { responseText: string; responseId: string; optionalComment?: string }>,
  questions: Question[]
): boolean {
  let shouldShow = true;
  if (revealedQuestionIds.has(q.id)) {
    shouldShow = false;
    for (const [questionId, response] of Object.entries(responses)) {
      // Check radio/option
      if (response.responseId) {
        const controllingQ = questions.find(qq => qq.id === questionId);
        const selectedOption = controllingQ?.options?.find(opt => opt.id.toString() === response.responseId.toString());
        if (selectedOption && selectedOption.revealQuestionId) {
          const revealedIds = selectedOption.revealQuestionId.split(',').map((id: string) => id.trim());
          if (revealedIds.includes(q.id)) {
            shouldShow = true;
            break;
          }
        }
      }
      // Check checkbox (multiple options)
      if (response.responseText) {
        const controllingQ = questions.find(qq => qq.id === questionId);
        const selectedOptionIds = response.responseText.split(',').map(s => s.trim());
        for (const selectedId of selectedOptionIds) {
          const selectedOption = controllingQ?.options?.find(opt => opt.id.toString() === selectedId);
          if (selectedOption && selectedOption.revealQuestionId) {
            const revealedIds = selectedOption.revealQuestionId.split(',').map((id: string) => id.trim());
            if (revealedIds.includes(q.id)) {
              shouldShow = true;
              break;
            }
          }
        }
      }
    }
  }
  return shouldShow;
}
